import { createDomain } from 'effector';

import { type Answers } from 'types/zod/answers';
import { QuestionnaireInstance } from 'types/zod/questionnaire-instance';

const domain = createDomain('answers');

export const $answers = domain.store<Record<QuestionnaireInstance['questionnaire_instance_id'], Answers> | null>(null);
